const trackedEvents = new Set<string>();

export function useGrowthBookTrack() {
  const { $growthbook } = useNuxtApp();

  function track(eventName: string, properties: Record<string, unknown> = {}) {
    const key = JSON.stringify({ eventName, properties });
    if (trackedEvents.has(key)) return;
    trackedEvents.add(key);
    if ($growthbook && 'logEvent' in $growthbook) $growthbook.logEvent(eventName, properties);
  }

  return { track };
}
